import { default as bookingsTvZaE5Jd3PMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookings.vue?macro=true";
import { default as bookingStartyEbytfx281Meta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookingStart.vue?macro=true";
import { default as calendarmIBKQThZTmMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/calendar.vue?macro=true";
import { default as generalsqwCksoxu4Meta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/general.vue?macro=true";
import { default as overview39UpCYyKRIMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/overview.vue?macro=true";
import { default as paymentWOwR6FZJfoMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/payment.vue?macro=true";
import { default as _91id_93Njouz0FgejMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id].vue?macro=true";
import { default as bookingHixsYIaR9lMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking.vue?macro=true";
import { default as indexaRYDU8UgdyMeta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/index.vue?macro=true";
import { default as requestDPmyiujUP2Meta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/request.vue?macro=true";
import { default as resourcesIFramejUqbgqy8D7Meta } from "/home/forge/amosweb.de/releases/20250708085539/booking/pages/resourcesIFrame.vue?macro=true";
export default [
  {
    name: "booking___de",
    path: "/booking",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking.vue").then(m => m.default || m),
    children: [
  {
    name: "booking-id___de",
    path: "/buchung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "booking-id-bookings___de",
    path: "buchungen",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookings.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-bookingStart___de",
    path: "start",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookingStart.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-calendar___de",
    path: "kalender",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/calendar.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-general___de",
    path: "allgemein",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/general.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-overview___de",
    path: "uebersicht",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/overview.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-payment___de",
    path: "payment",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/payment.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "booking___en",
    path: "/en/booking",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking.vue").then(m => m.default || m),
    children: [
  {
    name: "booking-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "booking-id-bookings___en",
    path: "/en/booking/bookings",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookings.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-bookingStart___en",
    path: "/en/booking/start",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/bookingStart.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-calendar___en",
    path: "/en/booking/calendar",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/calendar.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-general___en",
    path: "/en/booking/general",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/general.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-overview___en",
    path: "/en/booking/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/overview.vue").then(m => m.default || m)
  },
  {
    name: "booking-id-payment___en",
    path: "payment",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/booking/[id]/payment.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "request___de",
    path: "/request",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/request.vue").then(m => m.default || m)
  },
  {
    name: "request___en",
    path: "/en/request",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/request.vue").then(m => m.default || m)
  },
  {
    name: "resourcesIFrame___de",
    path: "/resourcesIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/resourcesIFrame.vue").then(m => m.default || m)
  },
  {
    name: "resourcesIFrame___en",
    path: "/en/resourcesIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250708085539/booking/pages/resourcesIFrame.vue").then(m => m.default || m)
  }
]